// import store from '@/store';

import store from '@/store';

export default class LG {
  /**
   * Wartet bis hcap bereit ist.
   * Auf alten WebOS-Versionen kann hcap noch nicht initialisiert sein
   * wenn die App startet – in diesem Fall auf das 'hcap-ready' Event warten.
   */
  static waitForHcap() {
    return new Promise((resolve) => {
      // hcap kann als globale Variable oder als window.hcap gesetzt sein
      try {
        if (typeof hcap !== 'undefined' && hcap !== null) {
          resolve();
          return;
        }
      } catch (e) { /* hcap noch nicht als Variable definiert */ }
      window.addEventListener('hcap-ready', resolve, { once: true });
    });
  }

  static get tvwindow() {
    if(hcap) return hcap.video;
    if(!window.hcap) return undefined;
    return window.hcap.video;
  }

  static get b2bControl() {
    if(hcap) return hcap.system;
    if(!window.hcap) return undefined;
    return window.hcap.system;
  }

  static get b2bPower() {
    if(hcap) return hcap.power;
    if(!window.hcap) return undefined;
    return window.hcap.power;
  }

  static get b2bMedia() {
    if(hcap) return hcap.media;
    if(!window.hcap) return undefined;
    return window.hcap.media;
  }

  static getModel() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "model_name",
          "onSuccess": (s) => { console.log("onSuccess LG getModel:", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getModel:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getModel: ', error);
        resolve('');
      }
    });
  }

  // Micom-Version (Mikrocontroller fuer Power/IR/Panel), z.B. "V3.03.6".
  //
  // Vertauscht mit getFirmware(): bis dahin lieferte getVersion() die
  // platform_version (in Wahrheit die Firmware, z.B. "03.62.00") und
  // getFirmware() die micom_version. Damit stand in der API unter "software"
  // die Micom-Version und die Firmware unter "version".
  // Verfuegbare Keys: platform_version / micom_version /
  // hcap_middleware_version / hcap_js_extension_version
  static getVersion() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "micom_version",
          "onSuccess": (s) => { console.log("onSuccess LG getVersion (micom_version):", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getVersion:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getVersion: ', error);
        resolve('');
      }
    });
  }

  static getIP() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.network.getNetworkInformation({
          "onSuccess": (s) => { console.log("onSuccess LG getIP:", s.ip_address); resolve(s.ip_address); },
          "onFailure": (f) => { console.log("onFailure LG getIP:", f.errorMessage); resolve('0.0.0.0'); }
        });
      } catch (error) {
        console.log('ERROR - LG.getIP: ', error);
        resolve('0.0.0.0');
      }
    });
  }

  static getMac() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.network.getNetworkDevice({
          "index": 0,
          "onSuccess": (r) => { console.log("onSuccess LG getMac:", r.mac); resolve(r.mac); },
          "onFailure": (r) => { console.log("onFailure LG getMac:", r.errorMessage); resolve('00:00:00:00:00'); }
        });
      } catch (error) {
        console.log('ERROR - LG.getMac: ', error);
        resolve('00:00:00:00:00');
      }
    });
  }

  // Firmware-/Softwarestand des TV, z.B. "03.62.00".
  //
  // Quelle ist die Property platform_version. Der Name ist irrefuehrend: das ist
  // NICHT die webOS-Generation, sondern der Softwarestand - derselbe Wert, den
  // die UserAgent im dritten Feld nennt: ( ;LGE ;43UK660H0LA... ;03.62.00 ;1 ).
  // Die webOS-Generation liefert DeviceType.getWebOSVersion.
  static getFirmware() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "platform_version",
          "onSuccess": (s) => { console.log("onSuccess LG getFirmware (platform_version):", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getFirmware:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getFirmware: ', error);
        resolve('');
      }
    });
  }

  static getWebOSVersion() {
    const ua = navigator.userAgent;
    const match = ua.match(/Web0S\s([\d.]+)/);
    return match ? match[1] : "Unknown";
  }

  static getPlatform() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "hcap_middleware_version",
          "onSuccess": (s) => resolve(s.value),
          "onFailure": () => resolve(LG.getWebOSVersion())
        });
      } catch (error) {
        resolve(LG.getWebOSVersion());
      }
    });
  }

  static getSerial() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "serial_number",
          "onSuccess": (s) => { console.log("onSuccess LG getSerial:", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getSerial:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getSerial: ', error);
        resolve('');
      }
    });
  }

  // Normalisiert eine HCAP-App-Liste auf [{id, name, version, type}].
  //
  // HCAP liefert die Liste NICHT als Array, sondern als Objekt mit numerischen
  // String-Keys (belegt durch get_preloaded_application_list):
  //   "list" : { "0" : {...}, "1" : {...}, "10" : {...} }
  // Beide Formen werden unterstuetzt; der Name steht je Firmware in app_name,
  // name oder title.
  static normalizeAppList(raw) {
    const container =
      (raw && (raw.application_list || raw.applicationList || raw.applications || raw.list)) || raw;
    let list = [];
    if (Array.isArray(container)) {
      list = container;
    } else if (container && typeof container === 'object') {
      list = Object.keys(container)
        .filter((k) => /^\d+$/.test(k))
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => container[k]);
    }
    return list
      .map((entry) => {
        const a = entry || {};
        return {
          id: String(a.app_id || a.appId || a.id || ''),
          name: a.app_name || a.appName || a.name || a.title || '',
          version: a.version || a.app_version || '',
          type: a.app_type || a.appType || a.type,
          // valid unterscheidet installiert von "nur im Katalog vorhanden".
          // Auf Hospitality stehen dort auch Apps mit valid=false.
          valid: a.valid,
          visible: a.visible,
        };
      })
      .filter((a) => a.id || a.name);
  }

  // Liefert alle auf dem TV installierten/registrierten Apps (Promise<Array>).
  // HCAP: hcap.application.getApplicationList.
  static getInstalledApps() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.application.getApplicationList({
          "onSuccess": (s) => {
            // try/catch zwingend: der Callback laeuft im hcap-Message-Handler.
            // Eine Exception hier wuerde resolve() nie erreichen und die
            // aufrufende Seite dauerhaft im Ladezustand haengen lassen.
            try {
              const list = LG.normalizeAppList(s);
              console.log("onSuccess LG getInstalledApps:", list.length);
              resolve(list);
            } catch (e) {
              console.log('ERROR - LG.getInstalledApps normalize: ', e);
              resolve([]);
            }
          },
          "onFailure": (f) => {
            console.log("onFailure LG getInstalledApps:", f && f.errorMessage);
            resolve([]);
          }
        });
      } catch (error) {
        console.log('ERROR - LG.getInstalledApps: ', error);
        resolve([]);
      }
    });
  }

  static get getResolutionHeight() {
    try {
      /*
      const resolution = tizen.systeminfo.getPropertyValue("DISPLAY", function(disp) {
        //console.log("==============DISPLAY-H", disp);
        //return {width: disp.resolutionWidth, height: disp.resolutionHeight};
        return disp.resolutionHeight;
      });
      return resolution;
      */
      return screen.height;
    } catch (error) {
      console.log(' error code = ' + error.code);
      return '';
    }
  }
  static get getResolutionWidth() {
    try {
      /*
      const resolution = tizen.systeminfo.getPropertyValue("DISPLAY", function(disp) {
        //console.log("==============DISPLAY-W", disp);
        //return {width: disp.resolutionWidth, height: disp.resolutionHeight};
        return disp.resolutionWidth;
      });
      return resolution;
      */
      return screen.width;
    } catch (error) {
      console.log(' error code = ' + error.code);
      return '';
    }
  }

  /*
  static set setSystemConfig(value) {
    try {
      webapis.productinfo.setSystemConfig(webapis.productinfo.ProductInfoConfigKey.CONFIG_KEY_DATA_SERVICE, value, onsuccess, onerror);
      return true;
    } catch (error) {
      console.log("ERRROR: Tizen setSystemConfig data = " + error.code);
      return false;
    }
  }

  static onsuccess(data)  {
    console.log("SUCCESS: Tizen setSystemConfig data = " + data);
  }
  static onerror(error)  {
    console.log("error code : " + error.code);
  }
  */

  static PowerState() {
    /*
    try {
      const PowerState = this.b2bPower.getPowerState();
      store.dispatch('notification/new', {
        title: 'Power State',
        message: PowerState,
      });
    } catch (e) {
      store.dispatch('notification/new', {
        title: e.name,
        message: e.message,
      });
      console.log(
        '[getPowerState] call syncFunction exception [' +
          e.code +
          '] name: ' +
          e.name +
          ' message: ' +
          e.message
      );
    }
    */
    hcap.power.getPowerMode({
      "onSuccess": function (s) {
          console.log("onSuccess power mode " + s.mode);
          store.dispatch('notification/new', {
            title: 'Power State',
            message: s.mode,
          });
      },
      "onFailure": function (f) {
          console.log("[getPowerMode] call syncFunction exception = " + f.errorMessage);
          // f, nicht e: der Parameter heisst f. Mit e lief der Fehlerpfad in
          // einen ReferenceError, statt die Meldung anzuzeigen.
          store.dispatch('notification/new', {
            title: 'Power State',
            message: f.errorMessage,
          });
      }
    });
  }
  static callbackSuccess(name, context) {
    console.log('CALLBACK_SUCCESS: ', name, ' with context: ', context);
  }
  static callbackError(name, context) {
    console.log('CALLBACK_ERROR: ', name, ' with context: ', context);
  }
  // Ausschalten = WARM-Standby, nicht power_off.
  //
  // hcap kennt zwei verschiedene Kommandos: set_power_mode (NORMAL/WARM) und
  // power_off. powerOff() faehrt das Geraet WIRKLICH herunter - was danach
  // passiert, entscheidet das Hotelmenue (Power On Default / Instant On), und
  // auf webOS 25 kam der TV damit sofort wieder hoch: er sah aus, als starte
  // er neu. Das Gegenstueck zu turnOn()s setPowerMode(NORMAL) ist
  // setPowerMode(WARM), der Instant-On-Standby.
  //
  // Daran haengt mehr als das Ausschalten selbst: die gesamte LG-Wake-Logik
  // (lgWakeToHome, lgCastPowerHook in main.js) setzt auf Warm-Standby, weil
  // WebOS die App dort im Speicher haelt und visibilitychange feuert. Nach
  // einem kalten power_off gibt es dieses Ereignis nicht - die App wird
  // abgeraeumt und startet neu.
  //
  // FALLBACK auf powerOff(): Ob jede aeltere Firmware (WebOS 3.5 aufwaerts)
  // WARM annimmt, ist nicht gesagt. Nimmt sie es nicht, meldet hcap onFailure
  // und es bleibt beim bisherigen Verhalten - lieber ein Geraet, das wie
  // frueher ausgeht, als eines, das gar nicht mehr ausgeht.
  static turnOff() {
    hcap.power.setPowerMode({
      "mode": hcap.power.PowerMode.WARM,
      "onSuccess": function () {
          console.log("onSuccess: turnOff (WARM-Standby)");
      },
      "onFailure": function (f) {
          console.log("onFailure turnOff (WARM-Standby): errorMessage = " + f.errorMessage);
          console.log("turnOff: Rueckfall auf power_off");
          hcap.power.powerOff({
            "onSuccess": function () {
                console.log("onSuccess: turnOff (power_off)");
            },
            "onFailure": function (f2) {
                console.log("onFailure turnOff (power_off): errorMessage = " + f2.errorMessage);
            }
          });
      }
    });
  }
  static turnOn() {
    //const cbSuccess = () => this.callbackSuccess('turnOn');
    //const cbError = (err) => this.callbackError('turnOn', err);
    //// this.PowerState();
    //// console.log('STATE: ', this.PowerState());
    //this.b2bPower.setPowerOn(cbSuccess, cbError);
    hcap.power.setPowerMode({
      "mode": hcap.power.PowerMode.NORMAL,
      "onSuccess": function () {
          console.log("onSuccess turnOn");
      },
      "onFailure": function (f) {
          console.log("onFailure turnOn: errorMessage = " + f.errorMessage);
      }
    });
  }

  static reboot() {
    //const cbSuccess = () => this.callbackSuccess('reboot');
    //const cbError = (err) => this.callbackError('reboot', err);
    //this.b2bControl.rebootDevice(cbSuccess, cbError);
    hcap.power.reboot({
      "onSuccess": function () {
          console.log("Success to reboot");
      },
      "onFailure": function (f) {
          console.log("Fail to reboot : " + f.errorMessage);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Device/LG.js